
import React from 'react';
import { Button } from '@/components/ui/button';
import { PitchCategory } from '@/types/pitch';

interface CategoryFilterProps {
  activeCategory: PitchCategory | 'all';
  onChange: (category: PitchCategory | 'all') => void;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({ activeCategory, onChange }) => {
  return (
    <div className="flex flex-wrap gap-2 mb-4">
      <Button 
        variant={activeCategory === 'all' ? 'default' : 'outline'} 
        size="sm"
        onClick={() => onChange('all')}
      >
        All
      </Button>
      <Button 
        variant={activeCategory === 'business' ? 'default' : 'outline'} 
        size="sm"
        onClick={() => onChange('business')}
      >
        Business
      </Button>
      <Button 
        variant={activeCategory === 'social_impact' ? 'default' : 'outline'} 
        size="sm"
        onClick={() => onChange('social_impact')}
      >
        Social Impact
      </Button>
      <Button 
        variant={activeCategory === 'creative' ? 'default' : 'outline'} 
        size="sm"
        onClick={() => onChange('creative')}
      >
        Creative
      </Button>
      <Button 
        variant={activeCategory === 'other' ? 'default' : 'outline'} 
        size="sm"
        onClick={() => onChange('other')}
      >
        Other
      </Button>
    </div>
  );
};

export default CategoryFilter;
